<template>
  <div>
    <div class="container-fluid bg-primary frontBanner">
      <div class="container">
        <div class="row">
          <div class="col-lg-2"></div>
          <div class="col-lg-8">
            <h1 class="text-uppercase">AIDS Impact<br />13th International Conference</h1>
            <h2>November 13th - 15th 2017, Cape Town</h2>
            <div v-if="this.authData">
            </div>
            <div class="input-group input-group-lg" v-else>
              <input type="email" class="form-control" v-model="txtEmail" placeholder="Your email address">
              <span class="input-group-btn">
                <button class="btn btn-default btn-info" type="button" v-on:click="subscribeForInfo">Please email me further information</button>
              </span>
            </div>
            <div class="alert alert-danger" role="alert" v-if="messageError">{{ messageError }}</div>
            <div class="alert alert-success" role="alert" v-if="messageSuccess">{{ messageSuccess }}</div>
          </div>
          <div class="col-lg-2"></div>
        </div>
      </div>
    </div>
    <div class="container aboutAIDSImpact text-center">
      <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <h2 class="text-uppercase">ABOUT <strong>AIDSIMPACT</strong></h2>
          <hr>
          <p class="lead">
            AIDSImpact is an international behavioral and psychosocial science conference that addresses issues related to HIV/AIDS prevention, treatment and care, focusing both globally and on specific communities and countries hardest hit by the HIV/AIDS epidemic.
          </p>
          <p class="lead">
            AIDSImpact first convened in Amsterdam in 1991. Now, in 2017 the 13th AIDSImpact conference will be held in Cape Town.
          </p>
          <p class="lead">
            Each AIDSImpact meeting attracts delegates new to the field as well as a core group of loyal psychosocial and behavioral researchers, prevention workers, community members and policy makers from universities and institutes across all five continents who use the biannual meeting to present their studies, interventions and prevention schemes. AIDSImpact has evolved as one of the leading platforms for understanding, updating and debating the behavioral, psychosocial and community facets of HIV in light of changing social conditions and medical advances. In fact, a review of past AIDSImpact scientific programs reveals the evolution of the psychosocial and behavioral response to the HIV epidemic over the past 25 years.
          </p>
          <p class="lead">
            The 2017 Cape Town conference will promote pioneering work on understanding the dynamics of a changing epidemic. A key focus will be consideration of new choices for HIV - for prevention, treatment, care and strategic planning.
          </p>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>
  </div>
</template>

<script>

  // global variables
  var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  
  import Vuex from 'vuex';
  import { mapState } from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase';
  import router from "../router"
  // end global variables

  // firebase initialisation
  var db = firebase.database();
  // end firebase initialisation

  // helper functions
  var queryString = function() {
      var qs = document.location.search.split('+').join(' ');
      var params = {},
          tokens,
          re = /[?&]?([^=]+)=([^&]*)/g;
      while (tokens = re.exec(qs)) {
          params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
      }
      return params;
  }();
  // end helper functions

  export default {
    name: "aboutus",
    computed: {
      ...mapState({
        // map e.g. this.authData to store.state.authData
        authData: 'authData',
      })
    },
    data () {
      return {
        txtEmail: '',
        messageError: null,
        messageSuccess: null,
        //queryString: queryString,
      }
    },
    firebase: {
      //users: db.ref('users'), // user database
      contacts: db.ref('contacts'), // contact database
      preauth: db.ref('pre-auth')
    },
    methods: {
      subscribeForInfo: function(evt) { // submits provided email address to contact database
        var email = this.txtEmail;
        var $target = $(event.target);
        this.messageError = null;
        this.messageSuccess = null;

        if (!regexEmail.test(email)) {
          this.messageError = 'Please enter a valid email address.';
          return;
        }
        $target.prop('disabled', true);
        firebase.database().ref('contacts/').push({
          "email": email,
          entered: firebase.database.ServerValue.TIMESTAMP
        }, $.proxy(function(error) {
          $target.prop('disabled', false);
          if (error) {
            this.messageError = 'Sorry. An error has occured';
          } else {
            this.messageSuccess = 'Thank you for submitting your details. We will contact you with further details.';
            $target.closest("div.input-group").hide();
          }
        }, this));
      },
      focusNextField: function (event) { // moves focus to next input field
        $(event.target).parent().next("div").find("input").focus();
      }
    },
    components: {
    }
  }
</script>



/** WEBPACK FOOTER **
 ** aboutus.vue?1cb001b0
 **/